import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateInterviewLogsShow } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

type Request = {
  candidateId: number;
  interviewLogId: number;
  enabled?: boolean;
};

export default function useFetchCandidateInterviewLog({
  candidateId,
  interviewLogId,
  enabled,
}: Request) {
  return useQuery({
    queryKey: ['candidateInterviewLogs', candidateId, interviewLogId],
    queryFn: async () => {
      const data = await fetchJson<AgentApiCandidateInterviewLogsShow>(
        `/agent/api/candidate_profiles/${candidateId}/candidate_interview_logs/${interviewLogId}.json`
      );

      return data;
    },
    enabled: enabled !== undefined ? enabled : true,
  });
}
